import { render, staticRenderFns } from "./CampoTexto.vue?vue&type=template&id=ee3e3540"
import script from "./CampoTexto.vue?vue&type=script&lang=js"
export * from "./CampoTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports